/**
 * Created by olga on 28.08.2025
 */

Placements.ENTRIES["restoreGenerators"] = {
    type: Placements.FREE_FOCUS,
    priority: 999,
    filter: function () {
        return Merge2.current && Merge2.current.generatorsToRestoreRewardsList;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "restoreGenerators",
            action: function (f) {
                const rewardsList = Merge2.current.generatorsToRestoreRewardsList;
                delete Merge2.current.generatorsToRestoreRewardsList;

                new RewardWindow(rewardsList);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

Placements.ENTRIES["showGeneratorMultiplierChanged"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: -1000,
    filter: function () {
        const generatorMultiplier = Merge2.current && Merge2.current.generatorMultiplier;
        return generatorMultiplier && generatorMultiplier.wantToShowChanged;
    },
    action: function () {
        const generatorMultiplier = Merge2.current.generatorMultiplier;

        const multiplier = generatorMultiplier.getValue();
        delete generatorMultiplier.wantToShowChanged;

        if (multiplier === 1) {
            cleverapps.centerHint.createTextHint(Messages.get("GeneratorMultiplier.offText"));
        } else {
            cleverapps.centerHint.createTextHint(Messages.get("GeneratorMultiplier.updateText", { multiplier }));
        }
    }
};

Placements.ENTRIES["startNextSideQuest"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: -1000,
    filter: function () {
        return Merge2.current && !Merge2.current.customers.getSideQuestCustomer()
       && cleverapps.unitsLibrary.isOpened(MergeCustomGeneratorTutorial.INGREDIENT_UNIT);
    },
    action: function () {
        Merge2.current.customers.startSideQuest(Merge2Customers.findSideQuestToStart());
    }
};